import {
  FilterRoute,
  SortDirection,
  SortOptionKey,
  SortOptionsMap,
} from '@zonofi/zono-money-store';

export const SORT_FILTERS: Record<FilterRoute, SortOptionsMap> = {
  [FilterRoute.Order]: {
    [SortOptionKey.Date]: {
      field: 'orderPlacedAt',
      display: {
        [SortDirection.Ascending]: 'Oldest to Newest',
        [SortDirection.Descending]: 'Newest to Oldest',
      },
      isDefault: SortDirection.Descending,
      selected: SortDirection.Descending,
    },
    [SortOptionKey.OrderAmount]: {
      field: 'orderedAmount',
      display: {
        [SortDirection.Ascending]: 'Low to High',
        [SortDirection.Descending]: 'High to Low',
      },
      selected: false,
    },
    [SortOptionKey.OrderSavings]: {
      field: 'orderSavings',
      display: {
        [SortDirection.Ascending]: 'Low to High',
        [SortDirection.Descending]: 'High to Low',
      },
      selected: false,
    },
  },
  [FilterRoute.Product]: {
    [SortOptionKey.Price]: {
      field: 'price',
      display: {
        [SortDirection.Ascending]: 'Low to High',
        [SortDirection.Descending]: 'High to Low',
      },
      selected: false,
    },
  },
  [FilterRoute.Pricing]: {},
  [FilterRoute.Payment]: {},
  [FilterRoute.Dispatch]: {},
  [FilterRoute.Invoice]: {},
  [FilterRoute.Conversation]: {},
  [FilterRoute.Ledger]: {},
  [FilterRoute.Customer]: {},
  [FilterRoute.Route]: {},
  [FilterRoute.Turnover]: {},
  [FilterRoute.CustomerOrder]: {},
  [FilterRoute.CustomerPayment]: {},
  [FilterRoute.CustomerInvoice]: {},
  [FilterRoute.CustomerDispatch]: {},
  [FilterRoute.SemanticQuery]: {},
};
